import React from 'react';
import { PropTypes } from 'prop-types';
import styled from 'styled-components';

import TrashIcon from '@icons/TrashIcon';
import { ButtonBase } from '@styled';
import Button from '../Button';
import colors from '@general/colors';

const IconButton = styled(ButtonBase)`
    background: ${colors.white};
    border-left: none;
    border-top: 1px solid ${colors.lightGray};
    border-right: 1px solid ${colors.lightGray};
    border-bottom: 1px solid ${colors.lightGray};
    height: 100%;
    padding-bottom: 0;
    padding-left: 4px;
    padding-right: 4px;
    padding-top: 0;
    text-align: center;
`;

const InputList = props => {
    const { list, buttonText, field, limit, arrayHelpers, name, ...inputProps } = props;
    const Field = field;

    return (
        <div>
            {list.map((item, index) => (
                <div key={index} className="d-flex align-items-stretch">
                    <div className="w-100">
                        <Field {...inputProps} name={`${name}[${index}]`} />
                    </div>

                    <div className="form-group">
                        <IconButton onClick={() => arrayHelpers.remove(index)}>
                            <TrashIcon />
                        </IconButton>
                    </div>
                </div>
            ))}

            {list.length < limit ||
                (!limit && (
                    <Button buttonClasses="mb-3" onClick={() => arrayHelpers.push('')}>
                        {buttonText}
                    </Button>
                ))}
        </div>
    );
};

InputList.propTypes = {
    list: PropTypes.array,
    limit: PropTypes.number,
    buttonText: PropTypes.string,
    name: PropTypes.string,
    field: PropTypes.any,
    arrayHelpers: PropTypes.any,
};

export default InputList;
